exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-card[data-v-fae5bece] {\n  max-width: 600px;\n  margin: 4px;\n  display: block;\n  vertical-align: top;\n}\n", ""]);

// exports
